// src/config/resourceSearch.js
// Configuration centralisée pour le moteur de recherche par ressource.

export const RESOURCE_SEARCH_CONFIG = {
    rdf: {
        label: 'RDF',
        placeholder: 'Rechercher un RDF (ID, subject, predicate...)',
        searchParam: 'q',
    },
    subjects: {
        label: 'Subjects',
        placeholder: 'Rechercher un subject (nom, auteur...)',
        searchParam: 'q',
    },
    'subject-variants': {
        label: 'Subject variants',
        placeholder: 'Rechercher une variante de subject',
        searchParam: 'q',
    },
    oobjects: {
        label: 'Oobjects',
        placeholder: 'Rechercher un oobject (nom, auteur...)',
        searchParam: 'q',
    },
    'oobject-variants': {
        label: 'Oobject variants',
        placeholder: "Rechercher une variante d'oobject",
        searchParam: 'q',
    },
    'comment-reports': {
        label: 'Comment Reports',
        placeholder: 'Rechercher un commentaire, auteur ou slug',
        searchParam: 'q',
    },
    'entity-reports': {
        label: 'Entity Reports',
        placeholder: 'Rechercher un RDF, sujet ou objet',
        searchParam: 'q',
    },
    predicates: {
        label: 'Predicates',
        placeholder: 'Rechercher un prédicat (code, libellé...)',
        searchParam: 'q',
    },
};

export const SEARCHABLE_RESOURCES = Object.keys(RESOURCE_SEARCH_CONFIG);

export const getResourceSearchConfig = (resource) =>
    resource ? RESOURCE_SEARCH_CONFIG[resource] ?? null : null;

export const isResourceSearchable = (resource) =>
    Boolean(getResourceSearchConfig(resource));

export const getSearchableResourceFromPath = (pathname = '') => {
    if (typeof pathname !== 'string') return null;

    const normalized = pathname.split('?')[0] || '';
    const segments = normalized.split('/').filter(Boolean);
    if (!segments.length) return null;

    const candidate = segments[0];
    return isResourceSearchable(candidate) ? candidate : null;
};
